import { Module } from 'framework/core';

import { PlatformModule } from '../platform/platform.module';
import { B2BService } from './b2b.service';

@Module({
  imports: [PlatformModule],
  providers: [B2BService],
})
export class B2BModule {}
